import axios from 'axios';

// 创建一个独立的 axios 实例用于日志上传
const logRequest = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 导出日志上传方法
export const uploadLog = async (logData) => {
  try {
    return await logRequest.post('/web/api/log', logData);
  } catch (error) {
    // 日志上传失败可以静默处理
    console.warn('日志上传失败:', error);
    return null;
  }
};

export default logRequest; 


// WEBPACK FOOTER //
// ./src/utils/log-request.js